import { render } from "./lesson1.vue?vue&type=template&id=f0a0b69a"
import script from "./lesson1.vue?vue&type=script&lang=js"
export * from "./lesson1.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__